import PropTypes from 'prop-types';
import { useState } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import { Link, Stack, Tooltip, IconButton, Popover, Typography, Box } from '@mui/material';
// components
import Iconify from '../../components/Iconify';
// utils
import { TELEGRAM_CHANNEL_URL, TELEGRAM_GROUP_URL } from '../../utils/social';

// ----------------------------------------------------------------------

const TELEGRAM_BLUE = '#26A5E4';

const OPTIONS = [
  {
    icon: 'mdi:bullhorn',
    label: 'Canal',
    description: 'Novedades y tips',
    href: TELEGRAM_CHANNEL_URL,
  },
  {
    icon: 'mdi:account-group',
    label: 'Grupo',
    description: 'Comunidad activa',
    href: TELEGRAM_GROUP_URL,
  },
];

TelegramMenu.propTypes = {
  isOffset: PropTypes.bool,
};

export default function TelegramMenu({ isOffset }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Tooltip title="Únete a nuestro Telegram" placement="bottom">
        <IconButton
          onClick={handleOpen}
          sx={{
            mr: 1,
            color: 'common.white',
            ...(isOffset && { color: TELEGRAM_BLUE }),
            '&:hover': { bgcolor: alpha(TELEGRAM_BLUE, 0.12) },
          }}
        >
          <Iconify icon="mdi:telegram" sx={{ width: 22, height: 22 }} />
        </IconButton>
      </Tooltip>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { p: 1.5, borderRadius: 2, width: 260 } }}
      >
        <Stack spacing={0.5}>
          {OPTIONS.map((opt) => (
            <Link
              key={opt.label}
              href={opt.href}
              target="_blank"
              rel="noopener"
              underline="none"
              onClick={handleClose}
            >
              <Stack
                direction="row"
                alignItems="center"
                spacing={2}
                sx={{
                  p: 1.25,
                  borderRadius: 1.5,
                  color: 'text.primary',
                  transition: 'background-color 0.2s',
                  '&:hover': { bgcolor: alpha(TELEGRAM_BLUE, 0.1) },
                }}
              >
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: alpha(TELEGRAM_BLUE, 0.15),
                    flexShrink: 0,
                  }}
                >
                  <Iconify icon={opt.icon} sx={{ width: 22, height: 22, color: TELEGRAM_BLUE }} />
                </Box>
                <Box>
                  <Typography variant="subtitle2">{opt.label}</Typography>
                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    {opt.description}
                  </Typography>
                </Box>
              </Stack>
            </Link>
          ))}
        </Stack>
      </Popover>
    </>
  );
}
